import { NoteOffOutlineIcon } from './NoteOffOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 321C9AFB-4A83-4B8F-A361-ADFA32318258
 * name note-off-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-off-outline.svg
 * tags
 */
export const PaperOffOutlineIcon = NoteOffOutlineIcon;
export default PaperOffOutlineIcon